// Forever Forward — header
// Adds .is-scrolled once the page moves past a threshold (drives the
// transparent→solid swap and the wordmark→icon swap on the home page),
// and runs the slide-in mobile drawer. No-ops gracefully without JS.

(function () {
  function initHeader(header) {
    if (!header || header.dataset.ffHeaderReady === 'true') return;
    header.dataset.ffHeaderReady = 'true';

    var threshold = parseInt(header.dataset.scrollThreshold, 10) || 40;
    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var scrolled = window.scrollY > threshold;
        header.classList.toggle('is-scrolled', scrolled);
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Mobile drawer
    var toggle = header.querySelector('[data-ff-nav-toggle]');
    var drawer = header.querySelector('[data-ff-drawer]');
    var closeEls = header.querySelectorAll('[data-ff-drawer-close]');

    function setOpen(open) {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      header.classList.toggle('drawer-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        setOpen(!drawer.classList.contains('is-open'));
      });
    }

    closeEls.forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  function init() {
    document.querySelectorAll('[data-ff-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
